import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "card-title" }, "汉化补丁下载:", -1)
const _hoisted_3 = { class: "demo-progress" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_col, { span: 24 }, {
    default: _withCtx(() => [
      _createVNode(_component_el_card, { class: "box-card" }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                type: "danger",
                size: "large",
                onClick: _ctx.uninstall,
                disabled: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _createTextVNode("卸载补丁 ")
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]),
              _createVNode(_component_el_button, {
                type: "success",
                size: "large",
                onClick: _ctx.get_mod_data,
                disabled: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _createTextVNode("获取补丁 ")
                ]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ])
          ])
        ]),
        default: _withCtx(() => [
          (_ctx.is_install)
            ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                    data: _ctx.filterTableData,
                    style: {"width":"100%"},
                    "element-loading-text": "加载中..."
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        label: "序号",
                        prop: "id",
                        width: "80"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "名字",
                        prop: "name"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "作者",
                        prop: "date"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "更新时间",
                        prop: "date"
                      }),
                      _createVNode(_component_el_table_column, {
                        align: "right",
                        width: "80"
                      }, {
                        header: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.search,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                            size: "small",
                            placeholder: "Type to search"
                          }, null, 8, ["modelValue"])
                        ]),
                        default: _withCtx((scope) => [
                          _createVNode(_component_el_button, {
                            size: "small",
                            type: "",
                            onClick: ($event: any) => (_ctx.handleinstall(scope.$index, scope.row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("安装 ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])), [
                    [_directive_loading, _ctx.loading]
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(_component_el_row, { style: {"text-align":"center"} }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, null, {
                default: _withCtx(() => [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.install_info.message), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { class: "center-col" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _withDirectives(_createVNode(_component_el_progress, {
                      "text-inside": true,
                      "stroke-width": 22,
                      percentage: _ctx.install_info.percentage,
                      status: _ctx.progressStatus,
                      duration: 3,
                      striped: "",
                      "striped-flow": ""
                    }, null, 8, ["percentage", "status"]), [
                      [_vShow, !_ctx.infoStatus]
                    ])
                  ])
                ]),
                _: 1
              }),
              _withDirectives(_createVNode(_component_el_col, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_button, {
                      type: "success",
                      size: "large",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.is_install=true;_ctx.restart_install_info()}),
                      round: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("确 定 ")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.infoStatus]
              ])
            ]),
            _: 1
          }, 512), [
            [_vShow, !_ctx.is_install]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}